import { Font } from "@/components/ui/Font";
import { Loader2 } from "lucide-react";

const PageLoader = ({ text, fixed = true }: { text?: string; fixed?: boolean }) => {
  return (
    <div className={`${fixed ? "fixed" : ""} inset-0 flex items-center justify-center flex-col pointer-events-none`}>
      <Loader2 className="h-16 w-16 text-[#b65bf3] animate-spin" />
      <Font family="roboto" weight={400}>
        <p dir="rtl" className="text-[#b65bf3] text-2xl  mt-2">
          {text ?? " טוען..."}
        </p>
      </Font>
    </div>
  );
};
export default PageLoader;
